import { moment } from "~/plugins/moment"

function centuryFromYear(year) {
  return Math.ceil(year / 100)
}

const romanize = (num) => {
  if (isNaN(num))
    return NaN;
  let digits = String(+num).split(""),
    key = ["", "C", "CC", "CCC", "CD", "D", "DC", "DCC", "DCCC", "CM",
      "", "X", "XX", "XXX", "XL", "L", "LX", "LXX", "LXXX", "XC",
      "", "I", "II", "III", "IV", "V", "VI", "VII", "VIII", "IX"],
    roman = "",
    i = 3;
  while (i--)
    roman = (key[+digits.pop() + (i * 10)] || "") + roman;
  return Array(+digits.join("") + 1).join("M") + roman;

}

const exportResult = (dates = [], formatting = "", resultType = 'plain') => {
  if (resultType === "plain") {
    switch (formatting) {
    case "day":
      return `${dates[0].format('DD.MM.y')}`
    case "month":
      return `${moment.months(dates[0].month())} ${dates[0].year()}`
    case "months":
      if (dates[0].year() === dates[1].year()) {
        return `${moment.months(dates[0].month())} - ${moment.months(dates[1].month())} ${dates[0].year()}`
      } else {
        return `${moment.months(dates[0].month())} ${dates[0].year()} - ${moment.months(dates[1].month())} ${dates[1].year()}`
      }
    case "year":
      return `${dates[0].year()}`
    case "years":
      return `${dates[0].year()} - ${dates[1].year()}`
    case "complete_range":
      return `${dates[0].format('DD.MM.y')} - ${dates[1].format('DD.MM.y')}`
    case "century":
      if (dates[1]) {
        return `${romanize(centuryFromYear(dates[0]))} - ${romanize(centuryFromYear(dates[1]))} век`
      } else return `${romanize(centuryFromYear(dates[0]))} век`
    case "century_part":
      return `${dates[1]} ${romanize(centuryFromYear(dates[0]))} века`
    case "epoch_complete_range":
      let leftBorder = ''
      let rightBorder = ''
      if ([dates[0], dates[1]].every(x => x.dateIsBCE())) {
        leftBorder = dates[0].year
        rightBorder = `${dates[1].year} гг. до н.э.`
      } else {
        leftBorder = `${dates[0].year} г. до н.э.`
        rightBorder = `${dates[1].format('DD.MM.y')}`
      }

      return `${leftBorder} - ${rightBorder}`
    case "epoch_complete_range_mixed":
      // Случай от до н.э. к н.э. с учетом наличия дня/месяца
      let leftPart = ''
      let rightPart = ''

      // Левая часть (до н.э.)
      if (dates[0].month === undefined && dates[0].day === undefined) {
        // Если день/месяц не указаны - показываем век
        leftPart = `${romanize(centuryFromYear(dates[0].year))} век до н.э.`
      } else {
        // Если день/месяц указаны - показываем дату
        leftPart = `${dates[0].format('DD.MM.y')} г. до н.э.`
      }

      // Правая часть (н.э.)
      if (dates[1].month === undefined && dates[1].day === undefined) {
        // Если день/месяц не указаны - показываем век
        rightPart = `${romanize(centuryFromYear(dates[1].year))} век`
      } else {
        // Если день/месяц указаны - показываем полную дату
        rightPart = `${dates[1].format('DD.MM.y')}`
      }

      return `${leftPart} - ${rightPart}`
    case "epoch_complete_range_smart":
      /* для лет больше 10000 меняем стороны местами */
      const leftYearUnit = detectUnitOfBCEDate(dates[0].year >= 1000000 ? dates[1].year : dates[0].year, dates[0].year > 12000)
      const rightYearUnit = detectUnitOfBCEDate(dates[0].year >= 1000000 ? dates[0].year : dates[1].year, dates[0].year > 12000)
      const units = {
        'bil': 'млрд',
        'mln': 'млн',
        'mil': 'тыс.',
        'int': '',
      }
      if (leftYearUnit[0] !== rightYearUnit[0]) {
        return `${leftYearUnit[1]} ${units[leftYearUnit[0]]} - ${rightYearUnit[1]} ${units[rightYearUnit[0]]} лет назад`
      } else {
        return `${leftYearUnit[1]} - ${rightYearUnit[1]} ${units[rightYearUnit[0]]} лет назад`
      }
    case "epoch_year":
      return `${dates[0].year} г. до н.э.`
    case "epoch_century":
      if (dates[1]) {
        return `${romanize(centuryFromYear(dates[0] - 1))} - ${romanize(centuryFromYear(dates[1]))} век до н.э.`
      } else return `${romanize(centuryFromYear(dates[0] - 1))} век до н.э.`
    case "epoch_century_part":
      return `${dates[1]} ${romanize(centuryFromYear(dates[0]))} века до н.э.`
    case "epoch_mil":
      if (dates[1]) return `${dates[0]}-e — ${dates[1]}-е тысячелетия до н.э.`
      return `${dates[0]}-е тысячелетие до н.э.`
    case "epoch_mil_part":
      return `${((dates[0].year + new Date().getFullYear()) / 1000).toLocaleString(undefined, { maximumFractionDigits: 3 })} тыс. лет назад`
    case "epoch_mln":
      return `${(dates[0].year / 1000000).toLocaleString(undefined, { maximumFractionDigits: 1 })} млн лет назад`
    case "epoch_bil":
      return `${(dates[0].year / 1000000000).toLocaleString(undefined, { maximumFractionDigits: 1 })} млрд лет назад`
    }
  } else if (resultType === "object") {
    switch (formatting) {
    case "day":
      return [[dates[0].format('D MMMM'), dates[0].format('y')]]
    case "month":
      return [[dates[0].format('MMMM'), dates[0].format('y')]]
    case "months":
      if (dates[0].year() === dates[1].year()) {
        return [
          [`${moment.months(dates[0].month())} - ${moment.months(dates[1].month())}`, `${dates[0].year()}`]
        ]
      } else {
        return [
          [moment.months(dates[0].month()), dates[0].year()],
          [moment.months(dates[1].month()), dates[1].year()],
        ]
      }
    case "year":
      return [[null, `${dates[0].format('y')}`]]
    case "years":
      return [[null, `${dates[0].format('y')}`], [null, `${dates[1].format('y')}`]]
    case "complete_range":
      return [[dates[0].format('D MMMM'), dates[0].format('y')], [dates[1].format('D MMMM'), dates[1].format('y')]]
    case "century":
      if (dates[1]) {
        return [[null, romanize(centuryFromYear(dates[0]))], [null, `${romanize(centuryFromYear(dates[1]))} век`]]
      } else {
        return [[null, `${romanize(centuryFromYear(dates[0]))} век`]]
      }
    case "century_part":
      return [[dates[1], `${romanize(centuryFromYear(dates[0] - 1))} века`]]
    case "epoch_complete_range":
      return [
        [`${dates[0].format('DD.MM.y')} г.`, 'до н.э.', true],
        [`${dates[1].format('DD.MM.y')} г.`, dates[1]?.dateIsBCE() ? 'до н.э.' : '&nbsp;', true],
      ]
    case "epoch_complete_range_mixed":
      // Случай от до н.э. к н.э. с учетом наличия дня/месяца (для объектного типа)
      let leftFormatted = ''
      let rightFormatted = ''

      // Левая часть (до н.э.)
      if (dates[0].month === undefined && dates[0].day === undefined) {
        // Если день/месяц не указаны - показываем век
        leftFormatted = [`${romanize(centuryFromYear(dates[0].year))} век`, 'до н.э.', true]
      } else {
        // Если день/месяц указаны - показываем дату
        leftFormatted = [`${dates[0].format('DD.MM.y')} г.`, 'до н.э.', true]
      }

      // Правая часть (н.э.)
      if (dates[1].month === undefined && dates[1].day === undefined) {
        // Если день/месяц не указаны - показываем век
        rightFormatted = [`${romanize(centuryFromYear(dates[1].year))} век`, '&nbsp;', true]
      } else {
        // Если день/месяц указаны - показываем полную дату
        rightFormatted = [`${dates[1].format('DD.MM.y')}`, '&nbsp;', true]
      }

      return [leftFormatted, rightFormatted]
    case "epoch_complete_range_smart":
      /* для лет больше 10000 меняем стороны местами */
      const leftYearUnit = detectUnitOfBCEDate(dates[0].year >= 1000000 ? dates[1].year : dates[0].year, dates[0].year > 12000)
      const rightYearUnit = detectUnitOfBCEDate(dates[0].year >= 1000000 ? dates[0].year : dates[1].year, dates[0].year > 12000)
      const units = {
        'bil': 'млрд',
        'mln': 'млн',
        'mil': 'тыс.',
        'int': '',
      }
      return [
        [`${leftYearUnit[1]} ${units[leftYearUnit[0]]}`, 'лет назад', true],
        [`${rightYearUnit[1]} ${units[rightYearUnit[0]]}`, 'лет назад', true],
      ]
    case "epoch_year":
      return [
        [`${dates[0].year} г.`, 'до н.э.', true],
      ]
    case "epoch_century":
      if (dates[1]) {
        return [[null, romanize(centuryFromYear(dates[0] - 1))], [null, `${romanize(centuryFromYear(dates[1]))} век до н.э.`]]
      } else {
        return [[null, `${romanize(centuryFromYear(dates[0] - 1))} век до н.э.`]]
      }
    case "epoch_century_part":
      return [[dates[1], `${romanize(centuryFromYear(dates[0] - 1))} века до н.э.`]]
    case "epoch_mil":
      if (dates[1]) {
        return [
          [`${dates[0]}-е тыс.`, 'до н.э.', true],
          [`${dates[1]}-е тыс.`, 'до н.э.', true]
        ]
      }
      return [
        [`${dates[0]}-е тыс.`, ' до н.э.', true]
      ]
    case "epoch_mil_part":
      return [
        [`${((dates[0].year + new Date().getFullYear()) / 1000).toLocaleString(undefined, { maximumFractionDigits: 3 })} тыс.`, 'лет назад', true]
      ]
    case "epoch_mln":
      return [
        [`${(dates[0].year / 1000000).toLocaleString(undefined, { maximumFractionDigits: 1 })} млн`, 'лет назад', true]
      ]
    case "epoch_bil":
      return [
        [`${(dates[0].year / 1000000000).toLocaleString(undefined, { maximumFractionDigits: 1 })} млрд`, 'лет назад', true]
      ]
    }
  }
}


const processCentury = (from_year, to_year, result_type = 'plain', prefix = '', inverse = false) => {
  if ((from_year - 1) % 100 === 0 && to_year % 100 === 0) {
    if ((to_year - from_year + 1) === 100) return exportResult([to_year], `${prefix}century`, result_type)
    return exportResult(inverse ? [to_year, from_year] : [from_year, to_year], `${prefix}century`, result_type)
  }

  /* 01.01.0201 - 31.12.0225 */
  if ((from_year - 1) % 100 === 0 && to_year % 25 === 0 && (to_year - from_year + 1) === 25) {
    return exportResult([from_year, inverse ? "конец" : "начало"], `${prefix}century_part`, result_type)
  }

  /* 01.01.0201 - 31.12.0250 */
  if ((from_year - 1) % 100 === 0 && to_year % 50 === 0 && (to_year - from_year + 1) === 50) {
    return exportResult([from_year, inverse ? "2 пол." : "1 пол."], `${prefix}century_part`, result_type)
  }

  /* 01.01.0276 - 31.12.0300 */
  if ((from_year - 1) % 25 === 0 && to_year % 50 === 0 && (to_year - from_year + 1) === 25 && (Number(to_year.toString().slice(-2)) !== 50)) {
    return exportResult([from_year, inverse ? "начало" : "конец"], `${prefix}century_part`, result_type)
  }

  /* 01.01.0251 - 31.12.0300 */
  if ((from_year - 1) % 50 === 0 && to_year % 50 === 0 && (to_year - from_year + 1) === 50) {
    return exportResult([from_year, inverse ? "1 пол." : "2 пол."], `${prefix}century_part`, result_type)
  }
}

const detectUnitOfBCEDate = (val, needJoinCurrentYear = false) => {
  if (val >= 1000000000) return ['bil', (val / 1000000000).toLocaleString(undefined, { maximumFractionDigits: 1 })]
  else if (val >= 1000000) return ['mln', (val / 1000000).toLocaleString(undefined, { maximumFractionDigits: 1 })]
  else {
    if (needJoinCurrentYear) val = val + new Date().getFullYear()
    if (val < 1000) return ['int', val]
    return ['mil', (val / 1000).toLocaleString(undefined, { maximumFractionDigits: 2 })]
  }
}

/**
 *
 * @param fromObj {Object}
 * @param toObj {Object}
 * @param resultType {string}
 */
export const datesToHuman = (fromObj, toObj, resultType = "plain") => {
  let parsedFrom = new VistatDate()
  let parsedTo = new VistatDate(undefined, undefined, undefined, false)

  if (fromObj.value instanceof VistatDate) {
    parsedFrom = fromObj.value
  } else {
    parsedFrom.parseString(fromObj.value)
  }
  if (toObj.value instanceof VistatDate) {
    parsedTo = toObj.value
  } else {
    parsedTo.parseString(toObj.value)
  }

  if (!parsedFrom.hasDate() && !parsedTo.hasDate()) return ""

  if (parsedFrom.hasDate() && toObj.value === null) {
    /* По настоящее время */
    if (resultType === 'plain') {
      return `${datesToHuman({ value: parsedFrom.toString() }, { value: parsedFrom.toString() }, resultType)} - по наст. время`
    } else {
      return [
        [`${datesToHuman({ value: parsedFrom.toString() }, { value: parsedFrom.toString() }, "plain")} -`, 'по наст. время', true]
      ]
    }
  }
  /* Если по какой-то причине источник оказался строковым */
  if (typeof parsedFrom === 'string') return `${parsedFrom} - ${parsedTo}`


  if ([parsedTo, parsedFrom].some(x => x.dateIsBCE())) {
    /* Одна из дат является датой до нашей эры */
    if (!parsedTo.hasDate() || parsedFrom.year === parsedTo.year) {
      if (parsedFrom.year > 1000000000) {
        return exportResult([(parsedFrom)], `epoch_bil`, resultType)
      }
      if (parsedFrom.year > 1000000) {
        return exportResult([(parsedFrom)], `epoch_mln`, resultType)
      }
      if (parsedFrom.year > 12000) {
        return exportResult([(parsedFrom)], `epoch_mil_part`, resultType)
      }

      return exportResult([parsedFrom], 'epoch_year', resultType)
    }

    if (parsedFrom.year <= 12000 && parsedTo.dateIsBCE()) {
      /* тысячелетия */
      if (parsedFrom.year % 1000 === 0 && parsedTo.year % 1000 === 1 && parsedTo.year > 1000) {
        if (parsedFrom.year - parsedTo.year === 1000 - 1) {
          // Одно
          return exportResult([parsedFrom.year / 1000], `epoch_mil`, resultType)
        } else {
          // Диапазон
          return exportResult([parsedFrom.year / 1000, (parsedTo.year - 1) / 1000], `epoch_mil`, resultType)
        }
      }
    }

    if (parsedFrom.year < 10000 && parsedTo.dateIsBCE()) {
      /* пытаемся смэтчить века. Добавляется смещение, потому что по другому считаем века до новой эры */
      let hasCentury = processCentury(parsedTo.year, parsedFrom.year, resultType, 'epoch_', true)
      if (hasCentury) return hasCentury
    }

    if (parsedTo.year === parsedFrom.year) return exportResult([parsedFrom], 'epoch_year', resultType)

    if (parsedFrom.year > 12000 && parsedTo.dateIsBCE()) {
      return exportResult([parsedFrom, parsedTo], 'epoch_complete_range_smart', resultType)
    }

    // Проверяем случай перехода от до н.э. к н.э.
    if (parsedFrom.dateIsBCE() && parsedTo.dateIsCE()) {
      return exportResult([parsedFrom, parsedTo], 'epoch_complete_range_mixed', resultType)
    }

    return exportResult([parsedFrom, parsedTo], 'epoch_complete_range', resultType)
  } else {
    /* Обе даты есть, обе в настоящем времени */
    let from = parsedFrom.getMomentJsInstance()
    let to = parsedTo.getMomentJsInstance()

    if (!parsedTo.hasDate() || parsedFrom.isSame(parsedTo, 'day')) return exportResult([parsedFrom.getMomentJsInstance()], 'day', resultType)

    if (
      from.isSame(to, 'month') &&
      from.isSame(from.clone().startOf('month'), 'day') &&
      to.isSame(to.clone().endOf('month'), 'day')
    ) {
      return exportResult([from], 'month', resultType)
    }

    if (
      from.isSame(to, 'year') &&
      from.isSame(from.clone().startOf('year'), 'day') &&
      to.isSame(to.clone().endOf('year'), 'day')
    ) {
      return exportResult([from], 'year', resultType)
    }

    if (from.isSame(from.clone().startOf('year'), 'day') && to.isSame(to.clone().endOf('year'), 'day')) {
      let hasCentury = processCentury(from.year(), to.year(), resultType)
      if (hasCentury) return hasCentury

      return exportResult([from, to], 'years', resultType)
    }

    /* 01.01.1344 - 31.08.1335 январь 1344 - август 1335 */
    /* 01.01.1344 - 31.08.1334 январь-август 1334 */
    if (
      from.isSame(from.clone().startOf('month'), 'day') &&
      to.isSame(to.clone().endOf('month'), 'day')
    ) {
      return exportResult([from, to], 'months', resultType)
    }
  }


  return exportResult([parsedFrom.getMomentJsInstance(), parsedTo.getMomentJsInstance()], 'complete_range', resultType)
}

/**
 * Кастомный конструктор дат, позволяющий работать с датой как с объектом и сохранять года до нашей эры
 */
export class VistatDate {
  year = undefined
  month = undefined
  day = undefined
  isBCE = false
  #DATE_FORMAT = 'YYYY.MM.DDTHH:mm:ss'
  defaultStartOf = true
  touched = false

  dateIsBCE() {
    return this.isBCE
  }

  dateIsCE() {
    return !this.isBCE
  }

  /**
   * Метод сравнит 2 даты, обе должны являться инстансом класса. Если одна или обе даты до нашей эры,
   * сравниваются только года
   * @param targetDate <VistatDate>
   */
  isAfter(targetDate) {
    if ([this, targetDate].some(x => x.dateIsBCE())) {
      // Одна из дат до н.э. /Сравниваем только года
      if (this.dateIsBCE() && targetDate.dateIsCE()) return false
      return targetDate.year < this.year
    } else {
      return this.getMomentJsInstance().isAfter(targetDate.getMomentJsInstance(), 'day')
    }
  }


  /**
   * Полное сравнение двух дат
   * @param targetDate VistatDate
   * @param granulatiry String
   * @return Boolean
   */
  isSame(targetDate, granulatiry = 'day') {
    if ([this, targetDate].some(x => x.dateIsBCE())) {
      // Одна из дат до н.э. /Сравниваем только года
      return this.year === targetDate.year
    } else {
      return this.getMomentJsInstance().isSame(targetDate.getMomentJsInstance(), granulatiry)
    }
  }

  endOf(unitOfTime = 'day') {
    if (this.dateIsBCE()) return true
    return this.getMomentJsInstance().endOf(unitOfTime)
  }

  startOf(unitOfTime = 'day') {
    if (this.dateIsBCE()) return true
    return this.getMomentJsInstance().startOf(unitOfTime)
  }

  /**
   * @param pattern {string}
   * @return {string}
   */
  format(pattern) {
    if (this.dateIsBCE()) return this.year || ""
    else return this.getMomentJsInstance().format(pattern)
  }

  /**
   * Конвертирует обычный объект в формат moment JS
   * @return {moment.Moment}
   */
  getMomentJsInstance({ year = this.year, month = this.month, day = this.day } = {}) {
    const fallBackMont = month === undefined ? (this.defaultStartOf ? 0 : 11) : month // Последний месяц года или первый, в зависимости от условий
    const maxDaysInMonth = moment({ year: year, month: fallBackMont, date: 1 }).daysInMonth()
    let fallbackDay = day

    if (fallbackDay === undefined) {
      if (this.defaultStartOf) {
        fallbackDay = 1
      } else {
        fallbackDay = maxDaysInMonth
      }
    }

    if (fallbackDay > maxDaysInMonth) fallbackDay = maxDaysInMonth

    return moment({
      year: year,
      month: fallBackMont,
      date: fallbackDay,
      hour: 0,
      minute: 0,
      second: 0
    })
  }

  toString() {
    if (this.hasDate()) {
      return this.dateIsBCE() ? `-${this.year}` : this.getMomentJsInstance().format(this.#DATE_FORMAT)
    } else {
      return null
    }
  }

  toObject() {
    return {
      year: this.year,
      month: this.month,
      day: this.day,
      isBCE: this.isBCE
    }
  }

  toRepresentation() {
    return {
      year: Number.isInteger(this.year) ? Math.abs(Math.abs(this.year)) : undefined,
      month: Number.isInteger(this.month) ? this.month : null,
      day: Number.isInteger(this.day) ? this.day : null,
      isBCE: this.dateIsBCE(),
      str_month: Number.isInteger(this.month) ? this.month.toString() : null,
    }
  }

  parseString(formattedDateString) {
    const parsed = moment(formattedDateString, this.#DATE_FORMAT)

    if (Number.isInteger(parseInt(formattedDateString)) && !formattedDateString.includes('.')) {
      const parsedYear = parseInt(formattedDateString)
      this.isBCE = parsedYear < 0
      this.year = Math.abs(parsedYear)
      this.month = undefined
      this.day = undefined
    } else if (parsed.isValid()) {
      this.year = parsed.year()
      this.month = parsed.month()
      this.day = parsed.date()
    } else {
      this.year = undefined
      this.month = undefined
      this.day = undefined
    }
  }

  reset() {
    this.year = undefined
    this.day = undefined
    this.month = undefined
    this.isBCE = false
    this.touched = false
  }

  hasDate() {
    return this.year !== undefined
  }

  setDay(val, setTouch = true) {
    const patchData = {
      day: val
    }

    if (setTouch) patchData.touched = true
    Object.assign(this, patchData)
  }

  setMonth(val, setTouch = true) {
    const patchData = {
      month: val
    }
    if (val === undefined) {
      patchData.day = undefined
    } else {
      const maxDaysInMont = this.getMomentJsInstance({ month: val, day: 1 }).daysInMonth()
      patchData.day = Math.min(maxDaysInMont, this.day) || undefined
    }
    if (setTouch) patchData.touched = true
    Object.assign(this, patchData)
  }

  setYear(val, setTouch = true) {
    this.year = val
    if (val !== undefined) {
      this.setMonth(this.month, setTouch)
    } else {
      this.day = undefined
      this.month = undefined
    }
    if (setTouch) this.touched = true
  }

  /**
   * @param flag {Boolean}
   */
  setEpoch(flag = false) {
    const patchData = {
      isBCE: flag
    }
    if (flag) {
      patchData.month = undefined
      patchData.day = undefined
    }

    Object.assign(this, patchData)
  }

  /**
   * @param targetDate {VistatDate}
   */
  sinkIntervalWith(targetDate) {
    if (this.defaultStartOf) {
      /* Сценарий, когда целевой объект - начало интервала (from) */
    } else {
      /* Сценарий, когда целевой объект - конец интервала (to) */
      this.year = targetDate.year
      this.month = targetDate.month
      this.day = targetDate.day || this.getMomentJsInstance({ day: 1 }).daysInMonth()
      this.isBCE = targetDate.isBCE
    }
  }

  constructor(year = undefined, month = undefined, day = undefined, defaultStartOf = true) {
    this.year = year
    this.month = month
    this.day = day
    this.defaultStartOf = defaultStartOf
  }
}
